import script from "./ProductCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCheckout.vue?vue&type=script&setup=true&lang=js"

import "./ProductCheckout.vue?vue&type=style&index=0&id=42dbff3f&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42dbff3f"]])

export default __exports__